import { MessageIn } from "../MessageIn.js";
import type { MessageIOContext } from "../MessageIOContext.js";
import { readJsonArray, readJsonString } from "../../../util/json.js";
import { APIEarnedAchievement } from "../api_schema.js";


export class MessageInUploadedGame extends MessageIn {
    public finishedGameID: string | null = null;
    public earnedAchievements: APIEarnedAchievement[] = [];

    read(_context: MessageIOContext, json: Record<string, any>): void {
        this.finishedGameID = readJsonString(json, "finished_game_id");

        const achievementsArray = readJsonArray(json, "earned_achievements");
        this.earnedAchievements = achievementsArray.map(item =>
            APIEarnedAchievement.parse(item),
        );
    }
}
